import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';

class ProtectedRoute extends Component {
  static contextType = AppContext;

  render() {
    const { state } = this.context;

    if (!state.isAuthenticated) {
      return <Navigate to="/login" />;
    }

    return this.props.children;
  }
}

export default ProtectedRoute;